<template>
	<div id="MainCardLayout">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="毕业生接收情况管理" />
        <HrrMainCardLayout>
            <template slot="custom">
              <el-tabs v-model="tab" type="card" @tab-click="handleClick">
                <el-tab-pane label="毕业生接收情况明细" name="first">
                    <template >
                        <el-button-group>
                            <el-button type="primary" icon="el-icon-edit" size="small" @click="AddDetailclick()">新增</el-button>
                            <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editDetailclick()">编辑</el-button>
                            <el-button type="primary" icon="el-icon-delete" size="small" @click="delDetailclick()">删除</el-button>
                        </el-button-group>
                    </template>
                    </br></br>
                    <template >
                        <el-table :data="tableData" ref="tableData" border stripe highlight-current-row style="width: 100%" @cell-click="cellDetailclick" @selection-change="selectionDetailchange">

                            <el-table-column type="selection" width="55" fixed="left">
                            </el-table-column>
                            <el-table-column prop="year" label="接收年份" width="180">
                            </el-table-column>
                            <el-table-column prop="companyName" label="单位名称" width="180">
                            </el-table-column>
                            <el-table-column prop="departmentName" label="部门名称" width="200">
                            </el-table-column>
                            <el-table-column prop="post" label="工作岗位(职位)" width="200">
                            </el-table-column>
                            <el-table-column prop="userName" label="姓名" width="100">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="180">
                            </el-table-column>
                            <el-table-column prop="isMain" label="是否主业" >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isMain=='0'" disable-transitions>否</span>
                                    <span v-if="scope.row.isMain=='1'" disable-transitions>是</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isOnjob" label="是否在岗" >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isOnjob=='0'" disable-transitions>否</span>
                                    <span v-if="scope.row.isOnjob=='1'" disable-transitions>是</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" >
                            </el-table-column>
                            <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button @click.stop="RowviewDetail(scope.row)" type="text" size="small">查看</el-button>
                                    <el-button @click.stop="RowEditDetail(scope.row)" type="text" size="small">编辑</el-button>
                                    <el-button @click.stop="RowdeleteDetail(scope.row)" type="text" size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    </br>
                    <template >
                        <el-pagination background @size-change="handleDetailSizeChange" @current-change="handleDetailCurrentChange" :current-page="searchDetailform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="totalDetail">
                        </el-pagination>
                    </template>
                </el-tab-pane>
                <el-tab-pane label="毕业生接收情况统计表" name="nine"> 
                    <template >
                        <el-button-group>
                            <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick()">新增</el-button>
                            <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick()">编辑</el-button>
                            <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick()">删除</el-button>
                        </el-button-group>
                    </template>
                    </br></br>
                            <el-table :data="tableDataS" ref="tableDataS" border stripe highlight-current-row style="width: 100%" @cell-click="cellclick" @selection-change="selectionchange">
                                <el-table-column type="selection" width="55" fixed="left">
                            </el-table-column>
                                <el-table-column prop="year" label="年份" width="180">
                                
                                </el-table-column>
                                <el-table-column prop="settleNum" label="实际接收落户人数" width="180">
                                    
                                </el-table-column>
                                <el-table-column prop="onjobNum" label="截止目前在岗人数" width="180">
                                    
                                </el-table-column>
                                <el-table-column prop="retentionRate" label="留存率" width="200">
                                    
                                </el-table-column>
                                <el-table-column label="制度建设情况">
                                <el-table-column prop="isCondition1" label="未制定毕业生招聘接收工作标准和规范">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isCondition1=='0'" disable-transitions>否</span>
                                    <span v-if="scope.row.isCondition1=='1'" disable-transitions>是</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isCondition2" label="已建立本单位毕业生招聘接收工作标准和规范">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isCondition2=='0'" disable-transitions>否</span>
                                    <span v-if="scope.row.isCondition2=='1'" disable-transitions>是</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="isCondition3" label="执行上级主管部门统一招聘接收工作标准和规范">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isCondition3=='0'" disable-transitions>否</span>
                                    <span v-if="scope.row.isCondition3=='1'" disable-transitions>是</span>
                                </template>
                            </el-table-column>
                            </el-table-column>
                            <el-table-column label="毕业招聘接收方式">
                                <el-table-column prop="isWay1" label="面向社会公开招聘" width="100">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.isWay1=='0'" disable-transitions>否</span>
                                        <span v-if="scope.row.isWay1=='1'" disable-transitions>是</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isWay2" label="校园招聘" width="100">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.isWay2=='0'" disable-transitions>否</span>
                                        <span v-if="scope.row.isWay2=='1'" disable-transitions>是</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isWay3" label="内部推荐" width="100">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.isWay3=='0'" disable-transitions>否</span>
                                        <span v-if="scope.row.isWay3=='1'" disable-transitions>是</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isWay4" label="其他" width="180">
                                </el-table-column>
                                <el-table-column label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
                                    <el-button @click.stop="RowEdit(scope.row)" type="text" size="small">编辑</el-button>
                                    <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small">删除</el-button>
                                </template>
                            </el-table-column>
                            </el-table-column>
                            </el-table>
                            <template >
                        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </template>
                </el-tab-pane>  
              </el-tabs>
            </template>


        </HrrMainCardLayout>
	</div>
</template>
<script>
    export default {
        name: 'report_graduate',
        data() {
            return {
                tab:"first",
                searchform: {
                    pageNum: 1,
                    pageSize: 10,
                },
                searchDetailform: {
                    pageNum: 1,
                    pageSize: 10,
                },
                path:"detail",
                postrules:{},
                tableData: [],
                tableDataS:[],
                form:[],
                tabIndex:0,
                total: 0,
                totalDetail:0,
                loading: true,
                selectionDetailRows:[],
                selectionRows:[],
                educationData:"",
				diplomaData:"",
                isAddOrEdit:true,
                isView:""
            }
        },
        methods: {
            handleClick(tab, event) {
                if(tab){    
                    this.tabIndex = tab.index;
                }
            },
            onSubmit() {

            },
            handleDetailSizeChange(val) {
				this.searchDetailform.pageSize=val;
				this.getGraduateList();
			},
			handleDetailCurrentChange(val) {
				this.searchDetailform.pageNum=val;
				this.getGraduateList();
			},
            handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.getSum();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.getSum();
			},
            //明细
            RowviewDetail(val) {
                const postid = val.prgId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/report/graduates/detail/view/' + postid
                });
            },
            RowEditDetail(val) {
                const postid = val.prgId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/report/graduates/detail/modify/' + postid
                });
            },
            RowdeleteDetail(val){
				this.$confirm("确定要删除选中的记录？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios.post(this.$api.plan.reportGDel,{prgdId:val.prgdId})
					.then((response)=>{
                        var redata=response.data;
                        // console.log(redata)
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.getGraduateList();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
            AddDetailclick() {
                this.$router.push({
                    path: '/plan/report/graduates/detail/add',
                });
            },
            editDetailclick(){
				if(this.selectionDetailRows.length==0)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				if(this.selectionDetailRows.length>1)
				{
					this.$message.warning("只能操作一行记录");
					return;
				}
                this.$route.meta.row=this.selectionDetailRows[0];
                // console.log(this.selectionRows[0])
				this.$router.push({path:'/plan/report/graduates/detail/edit/'+this.selectionDetailRows[0].prgdId});
			},
            delDetailclick(){
				if(this.selectionDetailRows.length<1)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				this.$confirm("确定要删除选中的记录？","删除提示",{type:"warning"}).then(()=>{
					var Vuethis=this;
					this.selectionDetailRows.forEach(row=>{
                        this.$hrraxios.post(this.$api.plan.reportGDel,{prgdId:row.prgdId})
                        .then((response)=>{
                            Vuethis.loading = false;
                            var data = response.data;
                            if (data.success == true) {
                                Vuethis.$message.success("删除成功");
                                Vuethis.getGraduateList();
                            } else {
                                Vuethis.$message.error(data.prompt);
                            }
                        })
                        .catch((error)=>{
                            console.log(error);
                        })
					});
				}).catch(()=>{

				});
			},
            //统计
            Rowview(val) {
                const postid = val.prgId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/report/graduates/sum/view/' + postid
                });
            },
            RowEdit(val) {
                const postid = val.prgId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/report/graduates/sum/modify/' + postid
                });
            },
            Rowdelete(val){
				this.$confirm("确定要删除 '"+val.year+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios.post(this.$api.plan.reportGSumDel,{prgId:val.prgId})
					.then((response)=>{
                        var redata=response.data;
                        // console.log(redata)
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.getSum();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
            Addclick() {
                this.$router.push({
                    path: '/plan/report/graduates/sum/add',
                });
            },
            editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message.warning("只能操作一行记录");
					return;
				}
                this.$route.meta.row=this.selectionRows[0];
                // console.log(this.selectionRows[0])
				this.$router.push({path:'/plan/report/graduates/sum/modify/'+this.selectionRows[0].prgId});
			},
            delclick(){    
				if(this.selectionRows.length<1)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				this.$confirm("确定要删除选中的记录？","删除提示",{type:"warning"}).then(()=>{
					var Vuethis=this;
					this.selectionRows.forEach(row=>{
                        this.$hrraxios.post(this.$api.plan.reportGSumDel,{prgId:row.prgId})
                        .then((response)=>{
                            Vuethis.loading = false;
                            var data = response.data;
                            if (data.success == true) {
                                Vuethis.$message.success("删除成功");
                                this.getSum();
                            } else {
                                Vuethis.$message.error(data.prompt);
                            }
                        })
                        .catch((error)=>{
                            console.log(error);
                        })
					});
				}).catch(()=>{

				});
			},
			cellDetailclick(row, column, cell, event){
                this.$refs.tableData.toggleRowSelection(row);
			},
            selectionDetailchange(selection){
				this.selectionDetailRows=selection;
			},
            cellclick(row, column, cell, event){
                this.$refs.tableDataS.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
            initData() {
                this.getGraduateList();
                this.getSum();
            },
            getGraduateList() {
                var Vuethis = this;
                this.loading = true;
                this.$hrraxios.get(this.$api.plan.reportGList, {
                        params: this.searchDetailform
                    })
                    .then(function(response) {
                        Vuethis.loading = false;
                        var data = response.data;
                        if (data.success == true) {
                            Vuethis.tableData = data.data.list;
                            Vuethis.totalDetail = data.data.total;
                            
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            },
            getSum(){
                var Vuethis = this;
                this.loading = true;
                this.$hrraxios.get(this.$api.plan.reportGSumList, {
                            params: this.searchform
                    })
                    .then(function(response) {
                        Vuethis.loading = false;
                        var data = response.data;
                        // console.log(data)
                        if (data.success == true) {
                            Vuethis.tableDataS = data.data.list;
                            Vuethis.total = data.data.total;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            },
        },
        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.initData();
        }
    }
</script>
